import React, { useState } from 'react';
import styles from 'styles/components/PreviewAndSend.module.css';
import QuestionFlow from '@ax2/takesurvey/components/question-flow/QuestionFlow';
import { useSurveyContext } from 'contexts/SurveyContext';
import SurveyComplete from './SurveyComplete';
import { launchSurvey } from 'rest/makeSurveyClient';
import { RestError } from '@ax2/common/rest/baseClient';
import Loading from '@ax2/common/components/Loading';
import { history } from '../helpers/router';
import { useErrorUpdateContext } from '@ax2/common/contexts/ErrorContext';
import Modal from '@ax2/common/components/Modal';
import { ActionButton } from '@ax2/common/components/ActionButton';
import config from '../config';
import { getErrorMessage } from '@ax2/common/helpers/error';
import { SurveyErrorReason } from '@ax2/common/helpers/error';
import {
  getOrder,
  getQuotasStatus,
  Order,
  saveIcon,
  saveOrder,
} from 'rest/shopClient';
import ConfirmationModal from './ConfirmationModal';

export interface PreviewSendListData {
  colorFunction: () => void;
  setcolor3false: () => void;
  setcolor3true: () => void;
}
export const PreviewAndSend: React.FC<PreviewSendListData> = props => {
  const surveySchema = useSurveyContext();
  const [order, setOrder] = useState<Order>(getOrder() || []);
  const updateError = useErrorUpdateContext();
  const [isSaving, setIsSaving] = useState(false);
  const [isLaunched, setIsLaunched] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [showQuota, setShowQuota] = useState(false);
  const [isdefaultQuota, setIsdefaultQuota] = useState(false);

  const handleFinish = () => {
    history.push('/dashboard');
  };

  return surveySchema ? (
    <div className={styles.previewAndSendOuterWrapper}>
      {isLaunched && (
        <Modal onClose={handleFinish}>
          <div className={styles.modalContent}>
            <span className={styles.launchCongrat}>
              Your survey is launched!
            </span>
            <span className={styles.launchInfo}>
              Launched surveys can be accessed by selecting
              <b> Sent/Active Surveys</b> tab on the Dashboard page.
            </span>
            <ActionButton text="Go to Dashboard" onClick={handleFinish} />
          </div>
        </Modal>
      )}
      <div className={styles.previewAndSendInnerWrapper}>
        <QuestionFlow
          checkAllStepColplete={() => props.setcolor3true()}
          screeners={surveySchema.screeners}
          questions={surveySchema.questions}
          isFastPreview={config.type === 'demo'} // We allow fast run there only in demo
          finalStep={{
            name: 'SEND',
            content: function fn(doBack) {
              function color() {
                if (surveySchema) {
                  saveIcon(`color3+${surveySchema.id}`, 'false');
                  props.setcolor3false();
                }
                doBack();
              }
              if (
                surveySchema &&
                getQuotasStatus(surveySchema.id) == false &&
                (surveySchema.panel == 'HealthPlanAndPbm' ||
                  surveySchema.panel == 'HealthPlanAndHospitalNetwork')
              ) {
                setIsdefaultQuota(true);
              }
              const handleSendPanelSurvey = async () => {
                if (isdefaultQuota) {
                  setIsConfirmationModalOpen(true);
                } else {
                  launchSurveyLogic();
                }
              };
              const launchSurveyLogic = async () => {
                setIsSaving(true);
                try {
                  await launchSurvey(surveySchema.id);
                  setIsSaving(false);
                  setIsLaunched(true);
                } catch (e) {
                  const restError = e as RestError;
                  setIsSaving(false);
                  updateError({
                    text: getErrorMessage(restError),
                    actions:
                      restError.reason ===
                      SurveyErrorReason.NoAvailableSurveySlot
                        ? [
                            {
                              text: 'Shop Panel Surveys',
                              onClick: () => {
                                if (surveySchema.specialty) {
                                  const newOrderItem = {
                                    panelType: surveySchema.panel,
                                    specialty: surveySchema.specialty,
                                    quantity: 1,
                                  };

                                  const newOrder: Order = [
                                    newOrderItem,
                                    ...order,
                                  ];
                                  setOrder(newOrder);
                                  saveOrder(newOrder);
                                  history.push('/purchase');
                                } else {
                                  const newOrderItem = {
                                    panelType: surveySchema.panel,
                                    quantity: 1,
                                  };

                                  const newOrder: Order = [
                                    newOrderItem,
                                    ...order,
                                  ];
                                  setOrder(newOrder);
                                  saveOrder(newOrder);
                                  history.push('/purchase');
                                }
                              },
                            },
                          ]
                        : [],
                  });
                }
              };
              const handleConfirmation = async (shouldProceed: boolean) => {
                setIsConfirmationModalOpen(false);
                if (shouldProceed) {
                  await launchSurveyLogic();
                } else {
                  setShowQuota(true);
                  return;
                }
              };
              return (
                <>
                  <SurveyComplete
                    surveyName={surveySchema.title ? surveySchema.title : ''}
                    panel={surveySchema.panel}
                    loading={isSaving}
                    back={{
                      title: 'Back',
                      onAction: color,
                    }}
                    setQuota={{
                      title: 'SetQuota',
                      onCancelQuota: () => setIsdefaultQuota(true),
                      onSaveQuota: () => setIsdefaultQuota(false),
                      onShow: () => setShowQuota(true),
                      onHide: () => setShowQuota(false),
                    }}
                    complete={{
                      title: 'Send Panel Survey',
                      onAction: async () => {
                        handleSendPanelSurvey();
                      },
                    }}
                    QuotaStatus={showQuota}
                  />
                  {isConfirmationModalOpen && (
                    <ConfirmationModal
                      onClose={() => handleConfirmation(false)}
                      text="You haven't set your survey quota's. Do you want to proceed with the default quota?"
                      actions={[
                        {
                          text: 'Yes',
                          onClick: () => handleConfirmation(true),
                        },
                        {
                          text: 'No',
                          onClick: () => handleConfirmation(false),
                        },
                      ]}
                    />
                  )}
                </>
              );
            },
          }}
          hasSkip={true}
          setPreviewColor={async () => props.colorFunction()}
        />
      </div>
    </div>
  ) : (
    <Loading paddingVertical={30} />
  );
};
